export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

export function readUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch (error) {
    return null;
  }
}

export function writeUser(user) {
  localStorage.setItem('user', JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem('user');
}

export function endpoint() {
  return process.env.REACT_APP_API_ENDPOINT || '';
}

export async function api(path, options = {}) {
  const user = options.user || readUser();
  const headers = { ...(options.headers || {}) };
  const isForm = typeof FormData !== 'undefined' && options.body instanceof FormData;
  if (!isForm && options.body !== undefined && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  if (!options.anonymous && user?.token && !headers.Authorization) {
    headers.Authorization = `JWTToken ${user.token}`;
  }
  const response = await fetch(`${endpoint()}${path}`, {
    method: options.method || 'GET',
    headers,
    body: (isForm || options.body === undefined) ? options.body : JSON.stringify(options.body),
  });
  if (response.status === 204) return null;
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (error) {
      data = { message: text };
    }
  }
  if (!response.ok) {
    throw new ApiError(response.status, data?.message || data?.error || response.statusText || 'Request failed');
  }
  return data;
}
